export enum DataSourcesTab {
    ALL ='ALL',
    DATASETS = 'DATASETS',
    EXTERNAL_TABLES = 'EXTERNAL-TABLES'
}
